const API_VERSION = 'v1';
const GOOGLE_MAPS_API_KEY = 'AIzaSyDGjGZfiKUfhOO6hZrPAK6-GIGv2ZB7tUA';
const DEV_TALKJS_APP_ID = "tfAbS9zj";
const PROD_TALKJS_APP_ID = "asGbDZQi";
const STRIPE_TEST_API_KEY = 'pk_test_EZPN8WHrXRF8honQ2f5LqhXV00Gv299fLR';
const STRIPE_LIVE_API_KEY = 'pk_live_WZ9KuT0SSyI6u6jptjSvvXZB00QvjEfft1';
const PLAID_PUBLIC_KEY = '2a787031c4ceb21484204546e52ca7';
const CONTACT_HELP_DESK_URL_PROD = 'https://tryfd.atlassian.net/servicedesk/customer/portal/3/group/4';
const CONTACT_HELP_DESK_URL_DEV = 'https://tryfd.atlassian.net/servicedesk/customer/portal/3/group/4';
const MAX_COUNT_REQUEST = 5;
const REFRESH_INTERVAL = 10000;

const local = {
  apiGateway: {
    protocol: 'http',
    url: 'localhost',
    port: '4000',
    apiVersion: API_VERSION
  },
  chat: {
    appId: DEV_TALKJS_APP_ID
  },
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  refreshInterval: REFRESH_INTERVAL,
  stripeApiKey: STRIPE_TEST_API_KEY,
  plaidKey: PLAID_PUBLIC_KEY,
  plaidEnv: 'sandbox',
  helpDeskUrl: CONTACT_HELP_DESK_URL_DEV,
  maxCountRequest: MAX_COUNT_REQUEST,
  appUrl: 'http://localhost:3000',
  shuttleTrackerUri: 'https://dev.po.stkr.orgadynamics.com/dashboard'
};

const dev = {
  apiGateway: {
    protocol: 'https',
    url: 'gw-dev.tryfd.com',
    port: '443',
    apiVersion: API_VERSION
  },
  chat: {
    appId: DEV_TALKJS_APP_ID
  },
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  refreshInterval: REFRESH_INTERVAL,
  stripeApiKey: STRIPE_TEST_API_KEY,
  plaidKey: PLAID_PUBLIC_KEY,
  plaidEnv: 'sandbox',
  helpDeskUrl: CONTACT_HELP_DESK_URL_DEV,
  maxCountRequest: MAX_COUNT_REQUEST,
  appUrl: 'https://app-dev.tryfd.com',
  shuttleTrackerUri: 'https://dev.po.stkr.orgadynamics.com/dashboard'
};

const stage = {
  apiGateway: {
    protocol: 'https',
    url: 'gw-stage.tryfd.com',
    port: '443',
    apiVersion: API_VERSION
  },
  chat: {
    appId: PROD_TALKJS_APP_ID
  },
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  refreshInterval: REFRESH_INTERVAL,
  stripeApiKey: STRIPE_LIVE_API_KEY,
  plaidKey: PLAID_PUBLIC_KEY,
  plaidEnv: 'production',
  helpDeskUrl: CONTACT_HELP_DESK_URL_PROD,
  maxCountRequest: MAX_COUNT_REQUEST,
  appUrl: 'https://app.tryfd.com',
  shuttleTrackerUri: 'https://po.stkr.orgadynamics.com/dashboard'
};

const sandbox = {
  apiGateway: {
    protocol: 'https',
    url: 'gw-sandbox.tryfd.com',
    port: '443',
    apiVersion: API_VERSION
  },
  chat: {
    appId: DEV_TALKJS_APP_ID
  },
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  refreshInterval: REFRESH_INTERVAL,
  stripeApiKey: STRIPE_TEST_API_KEY,
  plaidKey: PLAID_PUBLIC_KEY,
  plaidEnv: 'sandbox',
  helpDeskUrl: CONTACT_HELP_DESK_URL_DEV,
  maxCountRequest: MAX_COUNT_REQUEST,
  appUrl: 'https://app-sandbox.tryfd.com',
  shuttleTrackerUri: 'https://stage.po.stkr.orgadynamics.com/dashboard'
};

const prod = {
  apiGateway: {
    protocol: 'https',
    url: 'gw.tryfd.com',
    port: '443',
    apiVersion: API_VERSION
  },
  chat: {
    appId: ""
  },
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  refreshInterval: REFRESH_INTERVAL,
  stripeApiKey: STRIPE_LIVE_API_KEY,
  plaidKey: PLAID_PUBLIC_KEY,
  plaidEnv: 'production',
  helpDeskUrl: CONTACT_HELP_DESK_URL_PROD,
  maxCountRequest: MAX_COUNT_REQUEST,
  appUrl: 'https://app.tryfd.com',
  shuttleTrackerUri: 'https://po.stkr.orgadynamics.com/dashboard'
};

let processEnv = local;

switch (process.env.REACT_APP_STAGE) {
  case 'prod': 
    processEnv = prod;
    break;
  case 'dev':
    processEnv = dev;
    break;
  case 'stage':
    processEnv = stage;
    break;
  case 'sandbox':
    processEnv = sandbox;
    break;
  default: break;
}

export default processEnv;